import React, { memo, useRef, useMemo, useEffect, useCallback } from "react";

import classNames from "common/class-names";

export const ROW_HEIGHT = 44;
export const CENTER_INDEX = 2;

const AppTimeColumn = (props) => {
	const viewportRef = useRef();
	const { options, value, onChange } = props;

	//prettier-ignore
	const activeIndex = useMemo(() => {
		const index = options.findIndex((o) => o.value === value);

		if (index > -1) return index;

		let nearest = 0;

		options.forEach((o, i) => {
			if (Math.abs(o.value - value) < Math.abs(options[nearest].value - value)) nearest = i;
		});

		return nearest;
	}, [options, value]);

	//prettier-ignore
	const onHandleSelect = useCallback((option) => {
		if (option.isDisabled) return;

		onChange(option.value);
	}, [onChange]);

	//prettier-ignore
	const onHandleStep = useCallback((direction) => {
		const total = options.length;

		if (!total) return;

		for (let offset = 1; offset <= total; offset++) {
			const index = (((activeIndex + direction * offset) % total) + total) % total;

			if (!options[index].isDisabled) {
				onChange(options[index].value);
				return;
			}
		}
	}, [options, activeIndex, onChange]);

	useEffect(() => {
		const element = viewportRef.current;

		if (!element) return;

		const onHandleWheel = (event) => {
			event.preventDefault();
			onHandleStep(event.deltaY > 0 ? 1 : -1);
		};

		element.addEventListener("wheel", onHandleWheel, { passive: false });

		return () => element.removeEventListener("wheel", onHandleWheel);
	}, [onHandleStep]);

	return (
		<div className="app-time-column">
			<div className="app-time-column__viewport" ref={viewportRef}>
				<ul className="time-column" style={{ transform: "translateY(" + (CENTER_INDEX - activeIndex) * ROW_HEIGHT + "px)" }}>
					{options.map((o, i) => {
						const itemClassNames = classNames({
							"time-column__item": true,
							"time-column__item--active": i === activeIndex,
							"time-column__item--disabled": o.isDisabled,
						});

						return (
							<li key={o.value} aria-hidden="true" className={itemClassNames} onClick={() => onHandleSelect(o)}>
								{o.label}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

export default memo(AppTimeColumn);
